import React, { useEffect, useRef, useState } from 'react';
import { storage } from '../utils/storage';

function Analytics({ currentUser, onClose }) {
  const canvasRef = useRef(null);
  const [assessments, setAssessments] = useState([]);

  useEffect(() => {
    loadData();
  }, [currentUser]);

  const loadData = async () => {
    const user = await storage.getUser(currentUser);
    const userAssessments = user?.assessments || [];
    setAssessments(userAssessments);
  };

  useEffect(() => {
    if (assessments.length >= 0) {
      drawChart();
    }
  }, [assessments]);

  const drawChart = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    if (assessments.length === 0) {
      ctx.fillStyle = '#666';
      ctx.font = '16px Arial';
      ctx.fillText('No assessment data available', 50, 100);
      return;
    }
    
    const counts = {};
    assessments.forEach(a => counts[a.type] = (counts[a.type] || 0) + 1);
    
    const types = Object.keys(counts);
    const maxCount = Math.max(...Object.values(counts));
    const barWidth = canvas.width / types.length - 20;
    
    types.forEach((type, i) => {
      const height = (counts[type] / maxCount) * 150;
      const x = i * (barWidth + 20) + 10;
      const y = canvas.height - height - 30;
      
      ctx.fillStyle = '#667eea';
      ctx.fillRect(x, y, barWidth, height);
      
      ctx.fillStyle = '#333';
      ctx.font = '12px Arial';
      ctx.fillText(type, x, canvas.height - 10);
      ctx.fillText(counts[type], x + barWidth/2 - 5, y - 5);
    });
  };

  const getStats = () => {
    
    return {
      total: assessments.length,
      types: new Set(assessments.map(a => a.type)).size,
      last: assessments.length > 0 ? new Date(assessments[assessments.length - 1].date).toLocaleDateString() : 'Never'
    };
  };

  const stats = getStats();

  return (
    <section id="analytics-section">
      <h2>Progress Analytics</h2>
      <canvas ref={canvasRef} width="400" height="200"></canvas>
      <div id="analytics-summary">
        <div className="analytics-stat">
          <div><strong>{stats.total}</strong></div>
          <div>Total Assessments</div>
        </div>
        <div className="analytics-stat">
          <div><strong>{stats.types}</strong></div>
          <div>Assessment Types</div>
        </div>
        <div className="analytics-stat">
          <div><strong>{stats.last}</strong></div>
          <div>Last Assessment</div>
        </div>
      </div>
      <button onClick={onClose}>Close Analytics</button>
    </section>
  );
}

export default Analytics;